import {CLIENT_ERROR_CODES, CLIENT_ERROR_TYPES} from '../../constants';
import {BaseClientError} from './BaseClientError';
import {BaseServerError} from '../server';

export class InternalError extends BaseClientError {
  constructor(error?: BaseServerError) {
    super(CLIENT_ERROR_CODES.INTERNAL, CLIENT_ERROR_TYPES.INTERNAL, error && {message: error.message, stack: error.stack});
  }
}
